/* ==========================================================================
   Cube Club x Thrudaruf - video band behaviour
   THD-CUB-2026-01 - v3 - 7 Aug 2026

   Autoplay rules, in order of precedence:
   1. prefers-reduced-motion -> never autoplay. Poster + explicit play button.
   2. Save-Data on, or effectiveType 2g/slow-2g -> never autoplay.
   3. Otherwise: play when >=55% of the tile is on screen, pause when it
      leaves. Nothing is fetched before first intersection (preload=none,
      source attached lazily).

   Rendition: 480p unless the tile renders wider than ~900 device pixels.
   A 4-up desktop tile is ~315 CSS px, so 480p is already over 2x.

   Variant chips and the cart form are handled by tdf.js (the same
   data-tdf-* contract as the product card) - not duplicated here.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__tdfVideoBooted) return;
  window.__tdfVideoBooted = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || {};
  var thrifty = conn.saveData === true || /^(slow-)?2g$/.test(conn.effectiveType || '');
  var autoOK = !reduce && !thrifty;

  function attachSources(card) {
    var v = card.querySelector('video');
    if (!v || v.dataset.tdfSrcDone) return v;
    v.dataset.tdfSrcDone = '1';
    var need = card.getBoundingClientRect().width * (window.devicePixelRatio || 1);
    var hd = v.getAttribute('data-src-hd');
    var src = (need > 900 && hd) ? hd : v.getAttribute('data-src');
    if (src) {
      var s = document.createElement('source');
      s.src = src;
      s.type = 'video/mp4';
      v.appendChild(s);
      v.load();
    }
    return v;
  }

  function play(card) {
    var v = attachSources(card);
    if (!v) return;
    var p = v.play();
    if (p && p.then) {
      p.then(function () { card.classList.add('is-playing'); })
       .catch(function () { card.classList.add('is-manual'); });
    } else {
      card.classList.add('is-playing');
    }
  }

  function pause(card) {
    var v = card.querySelector('video');
    if (!v) return;
    v.pause();
    card.classList.remove('is-playing');
  }

  function bindTile(card) {
    if (card.dataset.tdfVBound) return;
    card.dataset.tdfVBound = '1';

    var btn = card.querySelector('[data-tdf-vplay]');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); play(card);
      });
    }

    /* tdf.js swaps price, variant id and poster on chip click, but it looks
       for the product-card class names. Keep the two links in sync here. */
    card.querySelectorAll('[data-tdf-sw]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var u = sw.getAttribute('data-variant-url');
        if (!u) return;
        var m = card.querySelector('.tdf-vc__media');
        var n = card.querySelector('.tdf-vc__name a');
        if (m) m.href = u;
        if (n) n.href = u;
      });
    });

    if (!autoOK || !('IntersectionObserver' in window)) {
      card.classList.add('is-manual');
      return;
    }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) play(card); else pause(card);
      });
    }, { threshold: 0.55 }).observe(card);
  }

  /* ---------- rail: arrows, ticks, and disabled states ---------- */
  function bindScroller(scroller) {
    if (scroller.dataset.tdfVBound) return;
    scroller.dataset.tdfVBound = '1';

    var band = scroller.closest('.tdf-vb');
    if (!band) return;
    var prev  = band.querySelector('[data-tdf-vprev]');
    var next  = band.querySelector('[data-tdf-vnext]');
    var ticks = band.querySelector('[data-tdf-vticks]');
    var dots  = ticks ? ticks.querySelectorAll('i') : [];
    var cells = scroller.querySelectorAll('.tdf-vb__cell');
    if (!cells.length) return;

    function page() {
      var cw = cells[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(scroller).columnGap || '20') || 20;
      var per = Math.max(1, Math.round(scroller.clientWidth / (cw + gap)));
      return per * (cw + gap);
    }

    function sync() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      var overflowing = max > 4;
      if (prev) { prev.disabled = scroller.scrollLeft <= 4; prev.hidden = !overflowing; }
      if (next) { next.disabled = scroller.scrollLeft >= max - 4; next.hidden = !overflowing; }
      if (dots.length) {
        var left = scroller.scrollLeft, best = 0, bestD = Infinity;
        cells.forEach(function (c, i) {
          var d = Math.abs(c.offsetLeft - scroller.offsetLeft - left);
          if (d < bestD) { bestD = d; best = i; }
        });
        dots.forEach(function (dot, i) { dot.classList.toggle('is-on', i === best); });
      }
    }

    if (prev) prev.addEventListener('click', function () { scroller.scrollLeft -= page(); });
    if (next) next.addEventListener('click', function () { scroller.scrollLeft += page(); });

    var frame = null;
    scroller.addEventListener('scroll', function () {
      if (frame) return;
      frame = requestAnimationFrame(function () { frame = null; sync(); });
    }, { passive: true });

    window.addEventListener('resize', sync, { passive: true });
    sync();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-tdf-vcard]').forEach(bindTile);
    (root || document).querySelectorAll('[data-tdf-vscroller]').forEach(bindScroller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
